
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"30","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"a","d":"M1.636 1.418h23.386V30H1.636z"}}),_c('path',{attrs:{"id":"c","d":"M1.636.119h23.386v28.582H1.636z"}})]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"stroke":"#E7E7E7","stroke-linecap":"square","d":"M-12.561-16h1076.122"}}),_c('g',{attrs:{"transform":"translate(-1 -.118)"}},[_c('mask',{attrs:{"id":"b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#a"}})]),_c('path',{attrs:{"d":"M4.234 1.418a2.603 2.603 0 00-2.598 2.598v23.386A2.603 2.603 0 004.234 30h18.19a2.602 2.602 0 002.598-2.598V9.212l-7.796-7.794H4.234z","fill":"#E4E4E4","mask":"url(#b)"}})]),_c('g',{attrs:{"transform":"translate(-1 -.118)"}},[_c('mask',{attrs:{"id":"d","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#c"}})]),_c('path',{attrs:{"d":"M4.234.119a2.602 2.602 0 00-2.598 2.598v23.386a2.603 2.603 0 002.598 2.598h18.19a2.602 2.602 0 002.598-2.598V7.913L17.226.119H4.234z","fill":"#ECECEC","mask":"url(#d)"}})]),_c('path',{attrs:{"d":"M24.021 7.795L16.227.001v5.194c0 1.43 1.162 2.6 2.598 2.6h5.196z","fill":"#DCDCDC"}})])])
          )
        }
      }
    